import { Routes, Route } from "react-router-dom";
import Converter from "./pages/Converter";
import Admin from "./pages/Admin";
import { useEffect } from "react";
import { trackVisit } from "./utils/visitorTracker";

function App() {
  useEffect(() => {
    trackVisit();
  }, []);

  return (
    <Routes>
      <Route path="/" element={<Converter />} />
      <Route path="/converter" element={<Converter />} />
      <Route path="/admin" element={<Admin />} />
    </Routes>
  );
}

export default App;

